import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import { getTotalPrice } from "Utils/Utils";

export class PurchaseOrderItemModel extends ModelBase<PurchaseOrderItemModel, PurchaseOrderItemModelDTO> {
    public id: string = "";
    public iELineId: string | null = null;
    public iEId: string | null = null;

    @MobX.observable
    public itemDescription: string = "";

    @MobX.observable
    public unitPrice: number = 0;

    @MobX.observable
    public quantity: number = 0;

    @MobX.observable
    public poNumber: number | null = null;

    @MobX.observable
    public formattedPONumber: string | null = null;

    fromDto(model: PurchaseOrderItemModelDTO): void {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else {
                    this[key] = model[key];
                }
            }
        }
    }

    public toDto(): PurchaseOrderItemModelDTO {
        const dto: PurchaseOrderItemModelDTO = {
            id: this.id,
            iELineId: this.id,
            iEId: this.id,
            itemDescription: this.id,
            unitPrice: this.unitPrice,
            quantity: this.quantity,
            poNumber: this.poNumber,
            formattedPONumber: this.formattedPONumber,
        };

        return dto;
    }

    public toListItemDto(): PurchaseOrderListItemModelDTO {
        return {
            id: this.id,
            itemDescription: this.itemDescription,
            poNumber: this.poNumber,
            committedCost: getTotalPrice(this.quantity, this.unitPrice),
            formattedPONumber: this.formattedPONumber,
        };
    }
}

export type PurchaseOrderItemModelDTO = {
    id: string;
    iELineId: string;
    iEId: string;
    itemDescription: string;
    unitPrice: number;
    quantity: number;
    poNumber: number | null;
    formattedPONumber: string | null;
};

export type PurchaseOrderListItemModelDTO = {
    id: string;
    itemDescription: string;
    committedCost: number;
    poNumber: number | null;
    formattedPONumber: string | null;
};
